module.exports = __webpack_public_path__ + "img/instagram.50f8a1ff.svg";